const palette = {
  LIGHT: {
    primary: {
      main: '#c1dfff',
      dark: '#90adcc',
      light: '#f4ffff',
    },
    secondary: {
      main: '#fff869',
      light: '#ffff9b',
      dark: '#c9c536',
    },
    error: {
      main: '#db2624',
    },
    background: {
      default: '#fdf9f6',
    },
  },
  DARK: {
    type: 'dark',
    primary: {
      main: '#040424',
      light: '#E70447',
      dark: '#04DBFF',
    },
    secondary: {
      main: '#DA0443',
      light: '#E70447',
      dark: '#C0043B',
    },
    error: {
      main: '#C2043C',
    },
    background: {
      default: '#1B2033',
    },
  },
};

export default palette;
